<template>
  <div :class="widgetData.container" id="location_country_regions">
    <div class="row mb-5">
      <div class="col-12">
        <h2>
          {{ $t('choose-region') }}
        </h2>
        <div class="w-md-50" v-html="widgetData.description">
        </div>
      </div>
      <div class="col-12 position-relative">
        <div id="location_country_regions_map" class="position-relative" ref="svgMapContent">
          <SvgIconMapCZ ref="svgMap" v-if="placeLocation.code === 'cs'"/>
          <SvgIconMapSK ref="svgMap" v-else/>
          <span class="map-popover" v-if="selectedRegion">
             {{ selectedRegion.title }}
             <br>
            <small>
              <TyIcon icon="ty-map-pointer" class="me-1 icon-color-first" height="1.3rem"/>
              {{ selectedRegion.count_of_accommodations }} &nbsp;{{
                $t($vysklonujSlovo('ponuk', selectedRegion.count_of_accommodations, 'y', '', 'a'))
              }}
            </small>
            <NuxtLink v-if="selectedRegion.page_urls[activeLocale.code]" class="d-block btn btn-first btn-rounded btn-sm mt-2"
                      :to="`/${selectedRegion.page_urls[activeLocale.code]}`">
              {{$t('accommodation-list-show-web')}}
            </NuxtLink>
          </span>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <h3 class="h4 mb-3">{{ $t('list-of-regions') }}</h3>
        <div class="row px-3">
          <div class="col-md-4 col-lg-3 location_region_detail_attractions mb-3 card-group ps-0" v-for="region in placeLocation.regions">

            <div class="card">
              <NuxtLink :to="regionHrefLang(region)" class="card" :class="{'active': hoveredElement === region.title}">
                <div class="card-header p-0">
                  <figure class="pointer mb-0">
                    <picture>
                      <PartsSrcSetImage v-if="region.hasImage()" :image="region.getTopImage()" :t_type="'thumbw'"
                                        :type="'webp'"/>
                      <PartsSrcSetImage v-if="region.hasImage()" :image="region.getTopImage()" :t_type="'thumbw'"
                                        :type="'jpeg'"/>

                      <img v-if="region.hasImage()"
                           :src="region.getTopImage().getTyrionSrc('thumbw')"
                           :alt="region.getTopImage().title" class="img-cover img-attraction" loading="lazy"
                           :width="region.getTopImage().seoWidth('thumb')" :height="region.getTopImage().seoHeight('thumb')">
                      <img v-else src="~/assets/img/blank.jpg" :alt="region.title" class="img-cover img-attraction" loading="lazy"
                           width="600" height="337">
                    </picture>
                  </figure>
                </div>
              </NuxtLink>
              <div class="card-body">
                <div class="row align-items-end d-flex">
                  <div class="col-12">
                    <p class="mb-0 h5">{{ region.langtitle[activeLocale.code] }} <span class="silver-for-text small">({{ region.count_of_accommodations }})</span></p>

                    <span>{{ typeof region.langdescription[activeLocale.code] === 'string' ? (region.langdescription[activeLocale.code].substring(0, 60) + '...') : '' }}</span>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, PropType, ref} from "vue";
import "~/assets/less/location_country_regions.min.css";
import "~/assets/less/location_region_detail_attractions.min.css";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/location";
import PlaceCountry from "~/lib/models/PlaceCountry";
import {createWebUrl} from "~/lib/functions";
import PlaceRegion from "~/lib/models/PlaceRegion";
import SvgIconMapCZ from "~/assets/icons/svg/ty-map-region-czech.svg";
import SvgIconMapSK from "~/assets/icons/svg/ty-map-region-slovakia.svg";
import {useNuxtApp} from "#app";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});
const mouseLeaveTimeout = ref(null);
const hoveredElement = ref(null);
const selectedRegion = ref<PlaceRegion | null>(null);
const svgMap = ref(null);
const {$vysklonujSlovo} = useNuxtApp();

const {widgetData, content, location, activeLocale} = useWidget(props.widget);
const placeLocation = computed(() => location as PlaceCountry)

const regionHrefLang = (region) => {
  return typeof region.page_urls === 'object' && region.page_urls[activeLocale.code] !== undefined ? `/${region.page_urls[activeLocale.code]}` : '#';
}

onMounted(() =>
    setTimeout(() => {

      svgMap.value.$el.querySelectorAll('a[data-title]').forEach((element) => {
        element.addEventListener('mouseenter', () => {
          hoveredElement.value = element.dataset.title;
          element.classList.add('hover');
          if (mouseLeaveTimeout.value !== null) {
            clearTimeout(mouseLeaveTimeout.value);
          }
        })
        element.addEventListener('click', () => {
          selectedRegion.value = null;
          svgMap.value.$el.querySelectorAll('a[data-title]').forEach((tElement) => {
            tElement.classList.remove('clicked');
          })

          const selectedTitle = createWebUrl(element.dataset.title)
          placeLocation.value.regions.forEach((region) => {
            if (region.code === selectedTitle) {
              selectedRegion.value = region;
              element.classList.add('clicked');
            }
          });
        })
        element.addEventListener('mouseleave', () => {
          element.classList.remove('hover');
          mouseLeaveTimeout.value = setTimeout(() => {
            mouseLeaveTimeout.value = null;
            hoveredElement.value = null;
          }, 150);
        })
      })

    }, 300)
)

</script>
